const BASE_URL = import.meta.env.VITE_APP_BASE_URL;

export { BASE_URL };
